import {action, makeObservable, observable} from "mobx";
import benefits from "../api/controllers/Benefits";
import {Benefit} from "../models/Benefit";

class Store {
  @observable public benefits?: Benefit[];

  constructor() {
    makeObservable(this);
  }

  @action public getBenefits = async () => {
    const data = await benefits.getAll();
    this.setBenefits(data);
  };

  @action public setBenefits = (benefits: Benefit[]) => {
    this.benefits = benefits;
  }
}

const BenefitsListStore = new Store();

export default BenefitsListStore;